module.exports = __webpack_public_path__ + "img/jingtanMap.8aa45c0d.png";